import {tourneesGraffitiConstants} from './tourneesGraffiti.constants';

const initialState = {
    items: null,
    loading: false,
    error: null,
};

export function tourneesGraffiti(state = initialState, action) {
    switch (action.type) {
        case tourneesGraffitiConstants.TOURNEES_GRAFFITI_FETCH_REQUEST:
            return { ...state, loading: true, error: null };
        case tourneesGraffitiConstants.TOURNEES_GRAFFITI_FETCH_SUCCESS:
            return { ...state, loading: false, items: action.items };
        case tourneesGraffitiConstants.TOURNEES_GRAFFITI_FETCH_FAILURE:
            return { ...state, loading: false, error: action.error };
        case tourneesGraffitiConstants.TOURNEES_GRAFFITI_DELETE_REQUEST:
            return { ...state, loading: true };
        case tourneesGraffitiConstants.TOURNEES_GRAFFITI_DELETE_SUCCESS:
            return { ...state, loading: false, items: (state.items || []).filter(i => i.id !== action.id) };
        case tourneesGraffitiConstants.TOURNEES_GRAFFITI_DELETE_FAILURE:
            return { ...state, loading: false, error: action.error };
        case tourneesGraffitiConstants.TOURNEES_GRAFFITI_CLEAR:
            return initialState;
        default:
            return state;
    }
}
